// extracted by mini-css-extract-plugin
export default {"slide":"Slides_slide__Izes3","slide--card":"Slides_slide--card__iUJqx","slide-button":"Slides_slide-button__jvjP6"};